import { Controller } from "@hotwired/stimulus";


export default class extends Controller {
  static targets = ["modal", "modalTitle", "approvalForm", "rejectComment"];

  connect() {
    document.addEventListener("click", this.handleClick);

  }

  disconnect() {
    document.removeEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    const modal = document.getElementById("approval-modal");
    const modalTitle = document.getElementById("modal-title");
    const approvalForm = document.getElementById("approval-form");
    const rejectComment = document.getElementById("reject-comment");
    const rejectionReason = document.getElementById("rejection-reason")
    const confirmButton = document.getElementById("confirm-button")
    const closeBtn = document.getElementById("close-button");
    
    if (event.target.matches(".btn-approve")) {
      modalTitle.textContent = "¿Aprobar la retención?";
      approvalForm.action = `/blocks/${event.target.dataset.blockId}/approve`;
      rejectComment.classList.add("hidden");
      confirmButton.disabled = false;
      modal.style.display = "block";
      event.preventDefault();
    }

    if (event.target.matches(".btn-reject")) {
      modalTitle.textContent = "¿Rechazar la retención?";
      approvalForm.action = `/blocks/${event.target.dataset.blockId}/reject`;
      rejectComment.classList.remove("hidden");
      confirmButton.disabled = true
      modal.style.display = "block";
      event.preventDefault();
    }


    rejectionReason.addEventListener("input", function () {
      confirmButton.disabled = rejectionReason.value.trim() === "";
    });

    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
    });

    window.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
      }
    });
  };
}
